import $ from "jquery";
import { useNavigate } from "react-router-dom";
import {
  AddIndirectBeneficiaries,
  EditIndirectBeneficiaries,
  GetSpecificIndirectBeneficiaries,
} from "../../../Redux/Reducers/ReportStage/IndirectBeneficiaries";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import InputAHSF from "../../../Components/InputAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";

const IndirectBeneficiariesForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const GetIndirectBeneficiaries = useSelector(
    (state) => state.IndirectBeneficiaries.IndirectBeneficiaries
  );

  const [Name, setName] = useState("");
  const [Role, setRole] = useState("");
  const [IndirectBeneficiariesValidation, setIndirectBeneficiariesValidation] =
    useState(false);

  // Fetch data in edit mode
  useEffect(() => {
    if (props.Action === "edit") {
      dispatch(
        GetSpecificIndirectBeneficiaries({
          indirectBeneficiariesId: props.indirectBeneficiariesId,
        })
      );
    }
  }, [dispatch, props.Action, props.indirectBeneficiariesId]);

  // Set state from store in edit mode
  useEffect(() => {
    if (props.Action === "edit" && GetIndirectBeneficiaries) {
      setName(GetIndirectBeneficiaries.indirectBeneficiariesName || "");
      setRole(GetIndirectBeneficiaries.roleInProject || "");
    }
  }, [props.Action, GetIndirectBeneficiaries]);

  const Validation = () => {
    const isNameEmpty = !Name || Name.trim() === "";
    const isRoleEmpty = !Role || Role.trim() === "";

    const hasError = isNameEmpty || isRoleEmpty;
    setIndirectBeneficiariesValidation(hasError);

    return !hasError;
  };

  const Add = () => {
    if (Validation()) {
      dispatch(
        AddIndirectBeneficiaries({
          indirectBeneficiariesName: Name.trim(),
          roleInProject: Role.trim(),
          reportStageId: props.reportStageId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
    }
  };

  const Edit = () => {
    if (Validation()) {
      dispatch(
        EditIndirectBeneficiaries({
          indirectBeneficiariesId: props.indirectBeneficiariesId,
          indirectBeneficiariesName: Name.trim(),
          roleInProject: Role.trim(),
          reportStageId: props.reportStageId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
      navigate(""); // Optional: replace with actual route
    }
  };

  const renderForm = () => (
    <>
      <InputAHSF
        fieldsName="IndirectBeneficiariesName"
        show={true}
        disabled={props.shouldDisableFields}
        defaultValue={
          props.Action == "edit"
            ? GetIndirectBeneficiaries?.indirectBeneficiariesName
            : ""
        }
        onChange={(e) => setName(e.target.value)}
        showValidationMessage={
          IndirectBeneficiariesValidation && (!Name || Name.trim() === "")
        }
        validationMessage="حقل الاسم إجباري"
      />

      <InputAHSF
        fieldsName="IndirectBeneficiariesRole"
        show={true}
        disabled={props.shouldDisableFields}
        defaultValue={
          props.Action == "edit" ? GetIndirectBeneficiaries?.roleInProject : ""
        }
        onChange={(e) => setRole(e.target.value)}
        showValidationMessage={
          IndirectBeneficiariesValidation && (!Role || Role.trim() === "")
        }
        validationMessage="حقل الدور إجباري"
      />

      <div className="ConainerButtonAHSF">
        <ButtonAHSF
          onClick={props.Action === "edit" ? Edit : Add}
          text="حفظ"
          show={true}
        />
      </div>
    </>
  );

  return (
    <>
      {props.Action === "edit"
        ? GetIndirectBeneficiaries?.indirectBeneficiariesId
          ? renderForm()
          : null
        : renderForm()}
    </>
  );
};

export default IndirectBeneficiariesForm;
